module.exports = __webpack_public_path__ + "static/media/service_s1.cc859cd4.png";